<div class="view-loader" role="dialog" #viewLoader>

  <div role="button" (click)="handleClick()">
    <ng-content></ng-content>
  </div>
  
</div>